import { render, staticRenderFns } from "./Interes_Simple_S_Cuatro.vue?vue&type=template&id=1b8fe14c&scoped=true&"
import script from "./Interes_Simple_S_Cuatro.vue?vue&type=script&lang=js&"
export * from "./Interes_Simple_S_Cuatro.vue?vue&type=script&lang=js&"
import style0 from "./Interes_Simple_S_Cuatro.vue?vue&type=style&index=0&id=1b8fe14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8fe14c",
  null
  
)

export default component.exports